import { SealRegistrationStatistics } from "./models";
import apiClient from "./api-client";

export interface CreateCheckoutSessionRequest {
  fullName: string;
  jobTitle: string;
  email: string;
  legalOrganizationName: string;
  registeredName: string;
  organizationWebsite: string;
  organizationCountry: string;
  roles: Record<string, boolean>;
  intendedUse: Record<string, boolean>;
  packagingConfirmation: boolean;
  vineyardUrls: string[];
  wineNotes: string;
  conferenceInterest: boolean;
  communicationsOptional: boolean;
  donationAmountInCents: number;
}

export interface CheckoutSessionResponse {
  url: string;
}

export interface SealRegistrationRecord {
  id: number;
  createdDate: string;
  fullName: string;
  jobTitle: string;
  email: string;
  legalOrganizationName: string;
  registeredName: string;
  organizationWebsite: string;
  organizationCountry: string;
  roles: string;
  intendedUses: string;
  packagingConfirmed: boolean;
  vineyardUrls: string;
  wineNotes: string;
  conferenceInterest: boolean;
  communicationsOptional: boolean;
  stripeCheckoutSessionId: string;
  stripePaymentIntentId: string;
  registrationFeeCents: number;
  donationAmountCents: number;
  totalAmountCents: number;
  currency: string;
  cardLastFour: string;
  paymentStatus: string;
}

export const createCheckoutSession = async (
  request: CreateCheckoutSessionRequest
): Promise<string> => {
  const response = await apiClient.post<CheckoutSessionResponse>(
    "/api/seal-registration/create-checkout-session",
    request
  );
  return response.data.url;
};

export const fetchRegistrationBySessionId = async (
  sessionId: string
): Promise<SealRegistrationRecord> => {
  const response = await apiClient.get<SealRegistrationRecord>(
    `/api/seal-registration/session/${sessionId}`
  );
  return response.data;
};

export interface SealRegistrationPage {
  content: SealRegistrationRecord[];
  totalElements: number;
  totalPages: number;
}

export const fetchSealRegistrations = async (
  order = "desc",
  pageSize = 1000,
  pageNumber = 0
): Promise<SealRegistrationPage> => {
  const response = await apiClient.get<SealRegistrationPage>(
    "/api/seal-registrations",
    { params: { order, pageSize, pageNumber } }
  );
  return response.data;
};

export const fetchSealRegistrationStatistics = async (): Promise<SealRegistrationStatistics> => {
  const response = await apiClient.get<SealRegistrationStatistics>(
    "/api/seal-registrations/statistics"
  );
  return response.data;
};
